import { render } from "./DropdownList.vue?vue&type=template&id=04b1d61e&scoped=true"
import script from "./DropdownList.vue?vue&type=script&lang=js"
export * from "./DropdownList.vue?vue&type=script&lang=js"

import "./DropdownList.vue?vue&type=style&index=0&id=04b1d61e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b1d61e"]])

export default __exports__